import { rtlLanguages } from "./constants";

export const isRtlLanguage = (language) => {
  let userLanguage;
  switch (language) {
    case "hi":
      userLanguage = "Hindi"
      break;
    case "mr":
      userLanguage = "Marathi"
      break;
    case "fa":
      userLanguage = "Farsi"
      break;
    case "fr":
      userLanguage = "French"
      break;
    case "ar":
      userLanguage = "Arabic"
      break;
    case "ur":
      userLanguage = "Urdu"
      break;
    case "or":
      userLanguage = "Odia"
      break;
    case 'en':
    default:
      userLanguage = "English"
  }

  return rtlLanguages.includes(userLanguage);
};

export const isTextRtl = (textContent) => {
  // Check for rtl based on char
  // Ref URL: https://stackoverflow.com/questions/12006095/javascript-how-to-check-if-character-is-rtl/14824756
  const ltrChars = 'A-Za-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02B8\u0300-\u0590\u0800-\u1FFF\u2C00-\uFB1C\uFDFE-\uFE6F\uFEFD-\uFFFF';
  const rtlChars = '\u0591-\u07FF\uFB1D-\uFDFD\uFE70-\uFEFC';
  const rtlDirCheck = new RegExp('^[^'+ltrChars+']*['+rtlChars+']');
  return rtlDirCheck.test(textContent);
}



// WEBPACK FOOTER //
// ./src/lib/appHelpers.js